import { LinkMacro } from './LinkMacro'
import { DestinationPrefix } from './DestinationPrefix'

export const prefixMacro = `${LinkMacro.Cdn}${DestinationPrefix.Ads}/${LinkMacro.AdId}`
